<template>
  <v-select
    :menu-props="{ bottom: true, offsetY: true }"
    item-value="id"
    item-text="name"
    return-object
    v-bind="$attrs"
    v-on="$listeners"
    class="ma-0"
  ></v-select>
</template>

<script>
export default {
  name: 'AppDropdown'
};
</script>
